import { SVGFC } from '@repo/toolkit/types'

const ChatIcon: SVGFC = ({ color = 'white', ...props }) => {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" {...props}>
      <g clipPath="url(#clip0_3293_65696)">
        <path
          d="M10.4173 8.4502C6.34649 8.4502 2.99955 11.2496 2.99955 14.6906C2.99955 16.0661 3.53308 17.464 4.51151 18.5475L3.12984 20.1264C2.99389 20.282 2.96091 20.5029 3.04694 20.6914C3.13244 20.8798 3.31989 21.0009 3.52689 21.0009H10.9447C13.9504 21.0009 17.8351 18.4127 17.8351 14.6906C17.8351 11.2496 14.4882 8.4502 10.4173 8.4502ZM7.21819 15.6572C6.63678 15.6572 6.16354 15.184 6.16354 14.6026C6.16354 14.0212 6.63681 13.5479 7.21819 13.5479C7.79957 13.5479 8.27285 14.0212 8.27285 14.6026C8.27288 15.184 7.79961 15.6572 7.21819 15.6572ZM10.4173 15.6572C9.83593 15.6572 9.36269 15.184 9.36269 14.6026C9.36269 14.0212 9.83596 13.5479 10.4173 13.5479C10.9987 13.5479 11.472 14.0212 11.472 14.6026C11.472 15.184 10.9988 15.6572 10.4173 15.6572ZM13.6165 15.6572C13.0351 15.6572 12.5618 15.184 12.5618 14.6026C12.5618 14.0212 13.0351 13.5479 13.6165 13.5479C14.1979 13.5479 14.6711 14.0212 14.6711 14.6026C14.6711 15.184 14.1979 15.6572 13.6165 15.6572Z"
          fill={color}
        />
        <path
          d="M20.8715 13.7314L19.6299 12.2828C20.5161 11.2828 20.9987 10.0633 20.9987 8.80162C20.9986 5.60314 17.9232 3.00098 14.1434 3.00098C10.7253 3.00098 7.82135 5.13106 7.30859 7.90351C8.26231 7.57944 9.33187 7.39523 10.4169 7.39523C15.0348 7.39523 18.8288 10.6206 18.8842 14.6023H20.4713C20.9218 14.6023 21.1637 14.0719 20.8715 13.7314Z"
          fill={color}
        />
      </g>
      <defs>
        <clipPath id="clip0_3293_65696">
          <rect width="18" height="18" fill={color} transform="translate(3 3)" />
        </clipPath>
      </defs>
    </svg>
  )
}

export default ChatIcon
